import styled from "@emotion/styled";
import { InputTextarea } from "primereact/inputtextarea";
import React from "react";
import { APP_CONSTANTS } from "@core/constants/app-constants";
import { useI18n } from "@core/i18n/i18n";
import { row, stack } from "@ui/style";
import { colors } from "@ui/style/colors";
import { fonts } from "@ui/style/font";

interface CustomMessageTextareaProps {
	value: string;
	maxLength: number;
	onChange: () => void;
}

export const CustomMessageTextarea = ({ value, maxLength, onChange }: CustomMessageTextareaProps): JSX.Element => {
	const { format } = useI18n();
	return (
		<Content>
			<InputTextarea rows={5} value={value} onChange={onChange} maxLength={maxLength} autoResize />
			<InfoContainer>
				<InfoText>
					{format("global.dialog.textInput.maxLength", {
						maxLength: APP_CONSTANTS.HEALTH_CARE_INVITE_MAX_CUSTOM_MESSAGE_LENGTH,
					})}
				</InfoText>
				<InfoText style={{ color: value.length === maxLength ? colors.rejection : colors.black }}>
					{maxLength - value.length}
				</InfoText>
			</InfoContainer>
		</Content>
	);
};

const Content = styled.div`
	${stack(8, "flexstart", "stretch")};
`;

const InfoContainer = styled.div`
	${row(undefined, "spacebetween", "flexend")}
	flex-wrap: wrap;
`;

const InfoText = styled.div`
	color: ${colors.black};
	margin: 8px;
	font-size: 12px;
	font-weight: 600;
	font-family: ${fonts.body};
`;
